import { useState, useEffect } from 'react';

const useInfiniteScroll = (callback: Function) => {
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
    // TODO: handle dependencies handleScroll
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isFetching) return;
    callback();
    // TODO: handle dependencies callback
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetching]);

  function handleScroll() {
    const { scrollTop, scrollHeight, clientHeight } = document.documentElement;

    if (scrollTop + clientHeight >= scrollHeight - 100) {
      setIsFetching(true);
    }
  }

  return [isFetching, setIsFetching] as const;
};

export default useInfiniteScroll;
